import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import employeeImage from "../../assets/images/employee_image.png";

const EmployeeOverview = () => {
  const basicInformationItem = (label, value) => {
    return (
      <Box sx={{flex: 1}}>
        <Typography fontSize="12px" color="#888888" >
          {label}
        </Typography>
        <Typography fontSize="12px" fontWeight="500" color="#474747" >
          {value}
        </Typography>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "30vh",
          display: "flex",
          alignItems: "center",
          padding: "0 2%",
        }}
      >
        {/* Employee Image */}
        <Box
          sx={{
            height: "25vh",
            width: "25vh",
            minWidth: "25vh",
            border: "1px solid #FFE097",
            borderRadius: "8px",
            marginRight: "4%",
          }}
        >
          <img
            src={employeeImage}
            width="100%"
            height="100%"
            alt="Employee"
            style={{ objectFit: "cover" }}
          />
        </Box>

        {/* Information Section */}
        <Box
          sx={{
            flex: 1,
            height: "25vh",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="body1"
            fontWeight="600"
            color="#DEA829"
            height="20%"
          >
            Basic Information
          </Typography>

          <Box
            sx={{
              display: "flex",
              height: "85%",
            }}
          >
            <Box
              sx={{
                width: "30%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
              }}
            >
              {basicInformationItem("Employee Name", "M.Steve Jack")}
              {basicInformationItem("Mobile No", "9876543210")}
              {basicInformationItem("Emergency Contact No", "987654321")}
            </Box>

            <Box
              sx={{
                width: "30%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
              }}
            >
              {basicInformationItem("DOB", "26-04-2002")}
              {basicInformationItem("Gender", "Male")}
              {basicInformationItem("Mail", "rahul@example.com")}
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={{ display: "flex", p: "4% 2%", height: '50vh'}}>
        <Box sx={{ display: "flex", flexDirection: "column", width: "30%",  justifyContent: 'flex-end', backgroundColor: 'red' }}>
          <Typography
            variant="body1"
            fontWeight="600"
            color="#DEA829"
          >
            Personal Information
          </Typography>
          {basicInformationItem("Marital Status", "Single")}
              {basicInformationItem("City", "Chennai")}
              {basicInformationItem("State", "Chennai")}
              {basicInformationItem("Country", "India")}
              {basicInformationItem("Address", "Bharathipuram Chrompet Chennai 6000044")}

        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", width: "70%",  justifyContent:'space-around', backgroundColor: 'yellow' }}>
          <Typography
            variant="body1"
            fontWeight="600"
            color="#DEA829"
          >
            Employee Information
  
          </Typography>
          <Box sx={{width: '100%', display: 'flex',  }}>
            {basicInformationItem("Designation", "Supervisor")}
            {basicInformationItem("Company", "Taj Hotel")}
            </Box>
            <Box sx={{width: '100%', display: 'flex',  }}>
            {basicInformationItem("Department", "HotelManagement")}
            {basicInformationItem("Duration", "2 Years")}
            </Box>
            <Box sx={{width: '100%', display: 'flex',  }}>
            {basicInformationItem("Employement Type", "Full")}
            {basicInformationItem("Education", "Arts")}
            </Box>
            <Box sx={{width: '100%', display: 'flex',  }}>
            {basicInformationItem("Date of Joining", "22-02-2022")}
            </Box>
            <Box sx={{width: '100%', display: 'flex',  }}>
            {basicInformationItem("Previous Experience", "Leela Palace, Chennai")}
            </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default EmployeeOverview;
